const marka = { t: 'Marka', name: 'marka', hint: { url: '/make/construction', cache: 'constr-make', exact: true }}
export default marka